import axios from "axios";
import { Constants } from "@constants";
import { queryStringToObject, getAuthorizationToken, deleteAuthorizationToken } from "@utils/utilities";

const apiService = axios.create({
  baseURL: `${Constants.API.API_PATH}`,
  withCredentials: true,
});

export const hasWindowLoader = (key) => {
  return !!window.__UCI_DATA__?.[key];
}

export const getWindowLoader = async (key) => {
  if (window.__UCI_DATA__?.[key]?.loading) {
    await window.__UCI_DATA__?.[key]?.promise;
    return window.__UCI_DATA__?.[key]?.data
  }
  else {
    return window.__UCI_DATA__?.[key]?.data
  }
}

const requestHandler = (request) => {
  const token = getAuthorizationToken(Constants.GENIE_ACCESS_CODE);
  request.headers.Authorization = token ? `Bearer ${token}` : "";
  request.headers["Cache-Control"] = "no-cache";
  return request;
};

const responseHandler = (response) => {
  let bearerToken = response?.headers?.[Constants.GENIE_ACCESS_CODE];
  if (bearerToken) {
    if (bearerToken?.toLowerCase()?.startsWith('bearer')) {
      bearerToken = bearerToken.replace(/^Bearer\s+/i, '');
    }
    localStorage.setItem(Constants.GENIE_ACCESS_CODE, bearerToken);
  }
  return response;
};

const errorHandler = (error) => {
  requestInterceptorsHandler(error);
  return Promise.reject(error);
};

apiService.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error)
);

apiService.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);

export const redirectToLogin = (host = "") => {
  const { login = false } = queryStringToObject(window?.location?.search);
    if (!login) {
    let HOST = host || `${window.location.origin}/account/signin?TARGET=`;
    if (origin.indexOf(Constants.ROUTES.APP_LOCAL_PATH) !== -1) {
      HOST = `${Constants.ROUTES.GENIE_AUTH_URL}?TARGET=`;
    }

    HOST = HOST + encodeURIComponent(window.location.href);

    window.location.replace(HOST);
  }
}

const requestInterceptorsHandler = (res) => {
  const origin = window.location.origin;
  const { response = {} } = res;
  if (response?.status === 401 || response?.data?.systemMessage?.code === 401) {
    deleteAuthorizationToken(Constants.GENIE_ACCESS_CODE);
    redirectToLogin(response?.data?.data?.host);
  }
};

export default apiService;
